import { useState, useRef, useEffect } from 'react';

interface Props {
  depth: number;
  titleColWidth: number;
  onSubmit: (title: string) => void;
  onCancel: () => void;
}

export default function WbsInlineCreate({ depth, titleColWidth, onSubmit, onCancel }: Props) {
  const [title, setTitle] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const submittedRef = useRef(false);
  const indent = (depth - 1) * 24;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.nativeEvent.isComposing) return;
    if (e.key === 'Enter' && title.trim() && !submittedRef.current) {
      submittedRef.current = true;
      onSubmit(title.trim());
    }
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <div
      className="flex items-center border-b bg-blue-50/50 text-sm"
      style={{ width: titleColWidth, minWidth: titleColWidth, paddingLeft: `${indent + 8 + 16 + 4}px` }}
    >
      <input
        ref={inputRef}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => {
          if (!submittedRef.current && !title.trim()) onCancel();
        }}
        placeholder="항목명을 입력하세요 (Enter: 확인, Esc: 취소)"
        className="flex-1 py-1.5 px-2 text-sm bg-transparent border-b-2 border-blue-300 focus:border-blue-500 outline-none"
      />
    </div>
  );
}
